import { globalState } from '@codeleap/store'
import { CommunityComment } from '@/types'

type ReplyStoreType = {
  parent?: CommunityComment | null
  reply?: CommunityComment | null
}

export const replyStore = globalState<ReplyStoreType>({ parent: null, reply: null })

export const setReplyParent = (comment: CommunityComment | null) => {
  replyStore.set({ ...replyStore.get(), parent: comment })
}

export const setReplyTo = (comment: CommunityComment | null) => {
  replyStore.set({ ...replyStore.get(), reply: comment })
}

export const resetReplyState = () => {
  replyStore.reset({ parent: null, reply: null })
}

export const reset = () => {
  replyStore.reset({ parent: null, reply: null })
}
